import React from 'react';
import SearchBar2 from '../SearchBar/SearchBar2';
import DataTable2 from '../DataTable2/DataTable2';
import PopupWithUseClickOutside from '../Popups/PopupWithUseClickOutside';
import Popup from '../Popups/Popup';
import DataTableDisplayLengthToggle from '../DataTable2/DataTableDisplayLengthToggle';
import Pagination from '../DataTable2/Pagination';
import Cell from '../DataTable2/DataTableComponents/Cell';
import NewAccountCard from '../Accounts/AccountCreationWorkflow/AccountTypeSelection/NewAccountCard';
import CloneAccountCard from './AccountCreationWorkflow/AccountTypeSelection/CloneAccountCard';
import CreateAccountForm from './AccountMgmt/CreateAccountForm';
import EditAccountForm from './AccountMgmt/EditAccountForm';

export default class AccountsIndexCard extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			sortOrder: 'asc',
			sortColumn: 'name',
			tempQuery: '',
			query: '',
			data: [],
			meta: {},
			apiKey: this.props.account_crud_api_key,
			cloneAccount: {
				id: null,
				name: null
			},
			get_account_endpoint: this.props.get_account_endpoint,
			newlyCreatedAccountName: '',
			isNewAccountCreated: false,
			isCreateAccountPopupVisible: false,
			isAccountProfilePopupVisible: false,
			isSuccessCardPopupVisible: false,
			isTimeoutCardPopupVisible: false,
			isAccountOptionsCardPopupVisible: false,
			isAccountEditCardPopupVisible: false,
			displayOptions: [
				10,
				25,
				50,
				100
			],
			currentPage: 1,
			pageLength: 25,
			pageNeighbours: 0
		};

		this.onChange = this.onChange.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.onChangeCloneExistingAccount = this.onChangeCloneExistingAccount.bind(
			this
		);
		this.onNewAccountCreation = this.onNewAccountCreation.bind(this);
		this.onChangeSortOrder = this.onChangeSortOrder.bind(this);
		this.onChangePageLength = this.onChangePageLength.bind(this);
		this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);
		this.onShowCreateAccountPopup = this.onShowCreateAccountPopup.bind(this);
		this.onHideCreateAccountPopup = this.onHideCreateAccountPopup.bind(this);
		this.onShowAccountProfilePopup = this.onShowAccountProfilePopup.bind(this);
		this.onHideAccountProfilePopup = this.onHideAccountProfilePopup.bind(this);
		this.onShowSuccessCardPopup = this.onShowSuccessCardPopup.bind(this);
		this.onHideSuccessCardPopup = this.onHideSuccessCardPopup.bind(this);
		this.onShowTimeoutCardPopup = this.onShowTimeoutCardPopup.bind(this);
		this.onHideTimeoutCardPopup = this.onHideTimeoutCardPopup.bind(this);
		this.onShowAccountOptionsCardPopup = this.onShowAccountOptionsCardPopup.bind(
			this
		);
		this.onHideAccountOptionsCardPopup = this.onHideAccountOptionsCardPopup.bind(
			this
		);
		this.onShowAccountEditCardPopup = this.onShowAccountEditCardPopup.bind(
			this
		);
		this.onHideAccountEditCardPopup = this.onHideAccountEditCardPopup.bind(
			this
		);
	}

	render() {
		// console.log(
		// 		'AccountIndexCard - Props',
		// 		this.props,
		// 	'AccountIndexCard - State',
		// 	this.state
		// );
		return (
			<div className="AccountsIndexCard card">
				<div className="card-body">
					<div className="row">
						<div className="col-6">
							<h1 className="card-title">
								<div className="UsersTitle">
									{I18n.t('admin.accounts')}{' '}
									<span>
										{this.state.meta.total_count ? (
											`(${this.state.meta.total_count})`
										) : (
											''
										)}
									</span>
								</div>
							</h1>
						</div>
						<div className="col-6">
							{this.props.permissionsHelper.hasCreateAccountPermissions() ? (
								<button
									type="button"
									id="new-user"
									className="btn btn-primary"
									onClick={this.onShowAccountOptionsCardPopup}
								>
									{I18n.t('account_setup.create_account_button')}
								</button>
							) : (
								''
							)}
						</div>
					</div>
					<div className="row filter-section">
						<div className="col-12">
							<SearchBar2
								placeholder={I18n.t('search_bar.placeholder')}
								name="tempQuery"
								value={this.state.tempQuery}
								onChange={this.onChange}
								onSubmit={this.onSearch}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<DataTable2
								// data={this.props.data}
								endpoint={this.buildEndpoint()}
								sortOrder={this.state.sortOrder}
								sortColumn={this.state.sortColumn}
								columns={[
									{
										displayName: 'ID',
										apiName: 'id',
										colNum: 1,
										colWidth: 10
									},
									{
										displayName: 'Organizations',
										apiName: 'organizations',
										colNum: 2,
										colWidth: 25,
										isSortable: false
									},
									{
										displayName: 'Account Name',
										apiName: 'name',
										colNum: 3,
										colWidth: 40
									},
									{
										displayName: 'Created on',
										apiName: 'created_at',
										colNum: 4,
										colWidth: ''
									},
									{
										displayName: '',
										apiName: 'edit',
										colNum: 2,
										colWidth: '',
										isSortable: false
									}
								]}
								rowRenderer={(d) => {
									return (
										<tr key={d.id}>
											<td>
												<Cell value={d.id} />
											</td>
											<td>
												<Cell
													value={d.organizations.map(
														(organization) => organization.name
													)}
												/>
											</td>
											<td>
												<Cell value={d.name} />
											</td>
											<td>
												<Cell value={d.created_at} type="date" />
											</td>
											<td>
												<Cell
													value={
														<div
															onClick={() => {
																this.onSetUrlPath(d.get_account_endpoint);
																this.onShowAccountEditCardPopup();
															}}
														>
															<i
																className="fa fa-ellipsis-h"
																aria-hidden="true"
															/>
														</div>
													}
												/>
											</td>
										</tr>
									);
								}}
								onChange={this.onChange}
								onChangeSortOrder={this.onChangeSortOrder}
								onShowUserProfilePopup={this.onShowUserProfilePopup}
								isNewAccountCreated={this.state.isNewAccountCreated}
								totalRecords={this.state.meta.total_count}
							/>
						</div>
					</div>
					<div className="row table-footer">
						<div className="col-12 col-sm-6">
							<Pagination
								totalRecords={
									this.state.meta.total_count ? this.state.meta.total_count : 0
								}
								pageLength={this.state.pageLength}
								currentPage={this.state.currentPage}
								pageNeighbours={this.state.pageNeighbours}
								onChangeCurrentPage={this.onChangeCurrentPage}
							/>
						</div>
						<div className="col-12 col-sm-6">
							<DataTableDisplayLengthToggle
								totalRecords={
									this.state.meta.total_count ? this.state.meta.total_count : 0
								}
								displayOptions={this.state.displayOptions}
								pageLength={this.state.pageLength}
								onChangePageLength={this.onChangePageLength}
							/>
						</div>
					</div>
				</div>
				<PopupWithUseClickOutside
					isPopupVisible={this.state.isCreateAccountPopupVisible}
					onHidePopup={this.onHideCreateAccountPopup}
				>
					<Popup
						title={
							this.state.cloneAccount && this.state.cloneAccount.id ? (
								<h1 className="card-title">
									{I18n.t('admin.clone_account_title')}
								</h1>
							) : (
								<h1 className="card-title">
									{I18n.t('admin.create_new_account_title')}
								</h1>
							)
						}
						onHidePopup={this.onHideCreateAccountPopup}
					>
						<CreateAccountForm
							public_id={this.props.public_id}
							permissionsHelper={this.props.permissionsHelper}
							onHidePopup={this.onHideCreateAccountPopup}
							iam_account_create_endpoint={
								this.props.iam_account_create_endpoint
							}
							cloneAccount={{
								id: this.state.cloneAccount.id,
								name: this.state.cloneAccount.name
							}}
							onNewAccountCreation={this.onNewAccountCreation}
							onShowSuccessCardPopup={this.onShowSuccessCardPopup}
							onShowTimeoutCardPopup={this.onShowTimeoutCardPopup}
						/>
					</Popup>
				</PopupWithUseClickOutside>
				<PopupWithUseClickOutside
					isPopupVisible={this.state.isSuccessCardPopupVisible}
					onHidePopup={this.onHideSuccessCardPopup}
				>
					<Popup
						title={
							<h1 className="card-title" style={{ color: 'green' }}>
								{I18n.t('success_card_title')}
							</h1>
						}
						body={
							this.state.newlyCreatedAccountName === true ? (
								I18n.t('admin.account.success_new_account', {
									newlyCreatedAccountName: this.state.newlyCreatedAccountName
								})
							) : (
								I18n.t('admin.account.success_update_account')
							)
						}
						onHidePopup={this.onHideSuccessCardPopup}
					/>
				</PopupWithUseClickOutside>
				<PopupWithUseClickOutside
					isPopupVisible={this.state.isTimeoutCardPopupVisible}
					onHidePopup={this.onHideTimeoutCardPopup}
				>
					<Popup
						title={
							<h1 className="card-title" style={{ color: 'red' }}>
								{I18n.t('timeout_card_title')}
							</h1>
						}
						body={I18n.t('timeout_card_body')}
						onHidePopup={this.onHideTimeoutCardPopup}
					/>
				</PopupWithUseClickOutside>
				<PopupWithUseClickOutside
					isPopupVisible={this.state.isAccountOptionsCardPopupVisible}
					onHidePopup={this.onHideAccountOptionsCardPopup}
					style={{ maxWidth: '850px' }}
				>
					<Popup
						title={
							<h1 className="card-title">
								{I18n.t('admin.account_setup_popup_title')}
							</h1>
						}
						onHidePopup={this.onHideAccountOptionsCardPopup}
					>
						<div className="container">
							<div className="row">
								<div className="col-6">
									<CloneAccountCard
										permissionsHelper={this.props.permissionsHelper}
										accounts_list_endpoint={this.props.accounts_list_endpoint}
										account_crud_api_key={this.props.account_crud_api_key}
										onChangeCloneExistingAccount={
											this.onChangeCloneExistingAccount
										}
										onHidePopup={this.onHideAccountOptionsCardPopup}
										onShowPopup={this.onShowCreateAccountPopup}
									/>
								</div>
								<div className="col-6">
									<NewAccountCard
										onHidePopup={this.onHideAccountOptionsCardPopup}
										onShowPopup={this.onShowCreateAccountPopup}
									/>
								</div>
							</div>
						</div>
					</Popup>
				</PopupWithUseClickOutside>
				<PopupWithUseClickOutside
					isPopupVisible={this.state.isAccountEditCardPopupVisible}
					onHidePopup={this.onHideAccountEditCardPopup}
					style={{ maxWidth: '850px' }}
				>
					<Popup
						title={
							<h1 className="card-title">{I18n.t('admin.edit_account')}</h1>
						}
						style={{
							maxHeight: '500px',
							overflow: 'auto'
						}}
						onHidePopup={this.onHideAccountEditCardPopup}
					>
						<div className="container">
							<div className="row">
								<div className="col-12">
									<EditAccountForm
										get_account_endpoint={this.state.get_account_endpoint}
										onShowSuccessCardPopup={this.onShowSuccessCardPopup}
										onHidePopup={this.onHideAccountEditCardPopup}
									/>
								</div>
							</div>
						</div>
					</Popup>
				</PopupWithUseClickOutside>
			</div>
		);
	}

	onChange(event) {
		const { name, value } = event.target;
		const { state } = this;
		state[name] = value;
		this.setState(state);
	}

	onChangePreDefinedAccount(e) {
		// console.log('onChangePreDefinedAccount', e);
		const { id = '', template_name = '' } = e;
		this.setState({
			cloneAccount: {
				id: id,
				name: template_name
			}
		});
	}

	onChangeCloneExistingAccount(e) {
		// console.log('onChangeCloneExistingAccount', e);
		const { id = '', text = '' } = e;
		this.setState({
			cloneAccount: {
				id: id,
				name: text
			}
		});
	}

	onSearch(event) {
		event.preventDefault();
		this.setState({ query: this.state.tempQuery });
	}

	onNewAccountCreation(accountName) {
		this.setState({
			isNewAccountCreated: !this.state.isNewAccountCreated,
			newlyCreatedAccountName: accountName,
			sortColumn: 'created_at',
			sortOrder: 'desc',
			currentPage: 1
		});
	}

	onChangeSortOrder(sortColumn, sortOrder) {
		if (sortOrder === '' || sortOrder === 'desc') {
			this.setState({
				sortColumn: sortColumn,
				sortOrder: 'asc',
				currentPage: 1
			});
		} else if (sortOrder === 'asc') {
			this.setState({
				sortColumn: sortColumn,
				sortOrder: 'desc',
				currentPage: 1
			});
		}
	}

	onChangeCurrentPage(currentPage) {
		this.setState({ currentPage: currentPage });
	}

	onChangePageLength(pageLength) {
		this.setState({ pageLength: pageLength, currentPage: 1 });
	}

	onSetUrlPath(url_path) {
		this.setState({ get_account_endpoint: url_path });
	}

	onShowCreateAccountPopup = () => {
		this.setState({ isCreateAccountPopupVisible: true });
	};

	onHideCreateAccountPopup = () => {
		this.setState({
			isCreateAccountPopupVisible: false,
			cloneAccount: {
				id: null,
				name: null
			}
		});
	};

	onShowAccountProfilePopup = () => {
		this.setState({ isAccountProfilePopupVisible: true });
	};

	onHideAccountProfilePopup = () => {
		this.setState({ isAccountProfilePopupVisible: false });
	};

	onShowSuccessCardPopup = () => {
		this.setState({ isSuccessCardPopupVisible: true });
	};

	onHideSuccessCardPopup = () => {
		this.setState({ isSuccessCardPopupVisible: false });
	};

	onShowTimeoutCardPopup = () => {
		this.setState({ isTimeoutCardPopupVisible: true });
	};

	onHideTimeoutCardPopup = () => {
		this.setState({ isTimeoutCardPopupVisible: false });
	};

	onShowAccountOptionsCardPopup = () => {
		this.setState({ isAccountOptionsCardPopupVisible: true });
	};

	onHideAccountOptionsCardPopup = () => {
		this.setState({ isAccountOptionsCardPopupVisible: false });
	};

	onShowAccountEditCardPopup() {
		this.setState({ isAccountEditCardPopupVisible: true });
	}

	onHideAccountEditCardPopup = () => {
		this.setState({ isAccountEditCardPopupVisible: false });
	};

	buildEndpoint() {
		return `${this.props.accounts_list_endpoint}?page=${this.state
			.currentPage}&results_per_page=${this.state.pageLength}&sort_column=${this
			.state.sortColumn}&sort_order=${this.state.sortOrder}&query=${this.state
			.query}&api_key=${this.state.apiKey}`;
	}
}
